<template>
  <v-container>
    <v-row>
      <v-col>
       <v-card class="mt-2">
          <v-toolbar color="primary" dark>
            <v-tabs v-model="tab">
              <v-tab>Register Ombrometer</v-tab>
              <v-tab>Register TMA</v-tab>
            </v-tabs>
          </v-toolbar>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <RegisterOmbro/>
              </v-tab-item>
              <v-tab-item>
                <RegisterTMA/>
              </v-tab-item>
            </v-tabs-items>
       </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RegisterOmbro from './Ombrometer/RegisterDeviceOmbro.vue'
import RegisterTMA from './TMA/RegisterDeviceTMA.vue'

export default {
  components: { RegisterTMA, RegisterOmbro },
  data: () => ({
    tab:null,
  }),
}
</script>